<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Visualizzazione</p>
                    <v-spacer></v-spacer>
                </v-card-title>                 
                <v-divider></v-divider>
                <v-container class="pa-0" fluid>
                    <v-row class="pa-4">
                        <v-list two-line subheader class="background-2 pa-2">
                            <v-list-item>
                                <v-list-item-action>
                                    <v-checkbox 
                                    color="primary" 
                                    hide-details
                                    v-model="settings['compact_viewing']"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Visualizzazione Schede</v-list-item-title>
                                    <v-list-item-subtitle>Campatta i panelli secondari delle schede
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-list two-line subheader class="background-2 pa-2">
                            <v-list-item>
                                <v-list-item-action>
                                    <v-checkbox 
                                    color="primary" 
                                    hide-details
                                    v-model="settings['product_code_search']"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Ricerca per codice prodotto esatto</v-list-item-title>
                                    <v-list-item-subtitle>Il codice trovato deve corrispondere esattamente con quello inserito 
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-list two-line subheader class="background-2 pa-2">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Caratteri minimi per ricerca prodotto</v-list-item-title>
                                    <v-list-item-subtitle>Numero di caratteri da inserire prima di avviare la ricerca automatica
                                    </v-list-item-subtitle>
                                    <v-text-field
                                        v-model.number="settings['product_search_min_chars']"
                                        type="number"
                                        min="1"
                                        max="10"
                                        dense
                                        outlined
                                        hide-details
                                        class="mt-2"
                                        style="max-width: 120px"
                                    ></v-text-field>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-row>
                </v-container>

                <v-divider></v-divider>
                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>

            <v-card elevation="1" class="background-2 round-card mt-4">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Notifiche</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container class="pa-0" fluid>
                    <v-row class="pa-4">
                        <v-list two-line subheader class="background-2 pa-2">
                            <v-list-item>
                                <v-list-item-action>
                                    <v-checkbox
                                    color="primary"
                                    hide-details
                                    v-model="settings['notification_snackbar_enabled']"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Notifiche in-app</v-list-item-title>
                                    <v-list-item-subtitle>Mostra una snackbar quando arriva una nuova notifica
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-list two-line subheader class="background-2 pa-2">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Durata notifica (secondi)</v-list-item-title>
                                    <v-list-item-subtitle>Tempo di visualizzazione della snackbar prima che scompaia
                                    </v-list-item-subtitle>
                                    <v-text-field
                                        v-model.number="settings['notification_snackbar_duration']"
                                        type="number"
                                        min="5"
                                        max="120"
                                        dense
                                        outlined
                                        hide-details
                                        class="mt-2"
                                        style="max-width: 120px"
                                        :disabled="!settings['notification_snackbar_enabled']"
                                    ></v-text-field>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    export default {
        name: 'settings-viewing',
        mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'viewing',
                settings: {
                    'compact_viewing': false,
                    'product_code_search': false,
                    'product_search_min_chars': 1,
                    'notification_snackbar_enabled': false,
                    'notification_snackbar_duration': 30,
                },
            }
        },
    }
</script>